// extracted by mini-css-extract-plugin
export default {"totalStyle":"TopContent_totalStyle__wGfDy","eachBox":"TopContent_eachBox__wcJVR","innerBox":"TopContent_innerBox__OIVJ2","textBox":"TopContent_textBox__ITX0C"};